import { render, staticRenderFns } from "./ClarenceNotifications.vue?vue&type=template&id=029f9d0a&scoped=true&"
import script from "./ClarenceNotifications.vue?vue&type=script&lang=js&"
export * from "./ClarenceNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ClarenceNotifications.vue?vue&type=style&index=0&id=029f9d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029f9d0a",
  null
  
)

export default component.exports